import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { UpdatePublicReceiveKeywordsCommand } from 'src/app/core/api/models/update-public-receive-keywords-command';
import { BaseFormPageComponent } from '../../../../shared/base/components/base-form-page.component';
import { CreatePublicReceiveKeywordCommand } from '.././../../../../core/api/models/create-public-receive-keyword-command';
import { ReceiveKeywordsService } from '.././../../../../core/api/services/receive-keywords.service';
import { FormPageConfig } from './../../../../../core/models/form-page-config.model';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';


@Component({
    selector: 'app-public-receive-keywords-form',
    templateUrl: './public-receive-keywords-form.component.html',
    imports: [BaseFormModule]
})
export class PublicReceiveKeywordsFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  pageVocabs = 'pages.assignNumbers.publicReceiveKeywords.form.';
  protected currentService = inject(ReceiveKeywordsService);
  formPageConfig: FormPageConfig<CreatePublicReceiveKeywordCommand> = {};

  model: CreatePublicReceiveKeywordCommand = {};

  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  initForm() {
    this.form = new FormGroup({
      privateNumberId: new FormControl('', Validators.required),
      organizationId: new FormControl(''),
    });
  }

  //#region Api

  //Create
  baseCreateApi(model: CreatePublicReceiveKeywordCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .receiveKeywordsCreatePublicReceiveKeywordPost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdatePublicReceiveKeywordsCommand): void {
    //this.baseCreateApi(model);
    //this.formPageConfig.isEditMode = false;
    this.unSubs();

    this.loading = true;

    this.currentService
      .receiveKeywordsUpdatePublicReceiveKeywordsPut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  getItems(event) {
    this.model.organizationIds = event;
  }
}
